import Input from './Input';
import RadioGroup from './RadioGroup';
import Select from './Select';
import MultipleSelect from './MultipleSelect';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import DatePickerYear from './DatePickerYear';
import Button from './Button';
import ActionButton from './ActionButton';

const Controls = {
  Input,
  RadioGroup,
  Select,
  MultipleSelect,
  Checkbox,
  DatePicker,
  DatePickerYear,
  Button,
  ActionButton,
};

export default Controls;
